import {
	Message
} from 'element-ui'
import axios from 'axios'
import Adapter from 'axios-mock-adapter'
import {
	get,
	isEmpty
} from 'lodash'
import qs from 'qs'
import util from '@/libs/util'
import store from '@/store'
import router from '@/router'

/**
 * @description 记录和显示错误
 * @param {Error} error 错误对象
 */
function handleError(error) {
	// 添加到日志
	store.dispatch('system/log/push', {
		message: '数据请求异常',
		type: 'danger',
		meta: {
			error
		}
	})
	// 打印到控制台
	if (process.env.NODE_ENV === 'development') {
		util.log.danger('>>>>>> Error >>>>>>')
		console.log(error)
		Message({
			message: error.message,
			type: 'error',
			duration: 1000
		})
	}
}

/**
 * @description 创建请求实例
 */
function createService() {
	// 创建一个 axios 实例
	const service = axios.create()
	// 请求拦截
	service.interceptors.request.use(
		config => config,
		error => {
			// 发送失败
			console.log(error)
			return Promise.reject(error)
		}
	)
	// 响应拦截
	service.interceptors.response.use(
		response => {
			return response.data
		},
		error => {
			const status = get(error, 'response.status')
			switch (status) {
				case 400:
					error.message = '请求错误';
					break
				case 401:
					error.message = '登录凭证已失效，正在尝试刷新登录凭证...';
					break
				case 403:
					error.message = '拒绝访问';
					break
				case 404:
					error.message = `未找到该资源: ${error.response.config.url}`;
					break
				case 408:
					error.message = '请求超时';
					break
				case 500:
					error.message = '服务器内部错误';
					break
				case 501:
					error.message = '服务未实现';
					break
				case 502:
					error.message = '网关错误';
					break
				case 503:
					error.message = '服务不可用';
					break
				case 504:
					error.message = '网关超时';
					break
				case 505:
					error.message = 'HTTP版本不受支持';
					break
				default:
					break
			}
			if (status === 401) {
				// Message({
				//   message: error.message,
				//   type: 'warning'
				// })
			} else if (status === 404) {
				if (process.env.NODE_ENV === 'development') {
					console.error(error.message)
				}
			} else {
				handleError(error)
			}
			throw error
		}
	)
	return service
}

function stringify(data) {
	return qs.stringify(data, {
		allowDots: true,
		encode: false
	})
}

/**
 * @description 创建请求方法
 * @param {Object} service axios 实例
 */
function createRequest(service) {
	return function(config) {
		const configDefault = {
			headers: {
				'Content-Type': get(config, 'headers.Content-Type', 'application/json')
			},
			timeout: 100000,
			baseURL: process.env.VUE_APP_API,
			data: {}
		}
		const option = Object.assign(configDefault, config)
		// 处理 get 请求的参数
		// 请根据实际需要修改
		if (!isEmpty(option.params)) {
			option.url = option.url + '?' + stringify(option.params)
			option.params = {}
		}

		if ((option.params === undefined || option.params.access_token === undefined) && (option.headers ===
				undefined || option.headers.Authorization === undefined)) {
			if (store.getters['system/account/isSigned']) {
				option.headers = option.headers || {}
				option.headers['Authorization'] = store.getters['system/account/Authorization']
			}
		}

		// 当需要以 form 形式发送时 处理发送的数据
		// 请根据实际需要修改
		if (!isEmpty(option.data) && option.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
			option.data = stringify(option.data)
		}
		return new Promise((resolve, reject) => {
			service(option).then(resolve, error => {
				const status = get(error, 'response.status')
				if ((status != 401) && (option.params === undefined || option.params
						.access_token === undefined)) {
					reject(error)
					return
				}
				const refresh_token = store.getters['system/account/refresh_token']
				if (refresh_token && refresh_token !== "undefined") {
					service({
						url: process.env.VUE_APP_TOKEN_URI,
						method: 'post',
						params: {
							grant_type: 'refresh_token',
							client_id: process.env.VUE_APP_CLIENT_ID,
							client_secret: process.env.VUE_APP_CLIENT_SECRET,
							refresh_token
						},
						auth: {
							username: process.env.VUE_APP_CLIENT_ID,
							password: process.env.VUE_APP_CLIENT_SECRET,
						},
					}).then(token => {
						store.commit('system/account/set_token', token)
						// Message({
						//   message: "已成功刷新登录凭证，正在尝试重新访问...",
						//   type: 'success'
						// })
						option['headers']['Authorization'] = store.getters[
							'system/account/Authorization']
						service(option).then(resolve, reject)
					}, () => {
						Message({
							message: "刷新凭证失败！请重新登录...",
							type: 'error'
						})
						router.push({
							name: 'login'
						})
					})
				} else {
					reject(error)
				}
			})
		})
	}
}

// 用于真实网络请求的实例和请求方法
export const service = createService()
export const request = createRequest(service)

// 用于模拟网络请求的实例和请求方法
export const serviceForMock = createService()
export const requestForMock = createRequest(serviceForMock)

// 网络请求数据模拟工具
export const mock = new Adapter(serviceForMock)
